import { exchangeMetafieldDisplayConfigSchema } from "@redotech/redo-return-core-common/exchange-metafield-display";
import type { infer as zInfer } from "zod";
import * as z from "zod";
import { shopifyMetafieldToDisplayInPortalSchema } from "./shopify-metafield-to-display-in-portal";

export const getShopifyIntegration = {
  name: "getShopifyIntegration" as const,
  input: z.object({}),
  output: z.union([
    z.object({
      skipRefunds: z.boolean(),
      enabled: z.boolean().nullish(),
      shopifyMetafieldsToDisplayInPortal: z
        .array(shopifyMetafieldToDisplayInPortalSchema)
        .nullish(),
      shopifyMetafieldsToDisplayOnExchangeItems: z
        .array(exchangeMetafieldDisplayConfigSchema)
        .nullish(),
    }),
    z.undefined(),
  ]),
};

export type ShopifyIntegration = zInfer<typeof getShopifyIntegration.output>;
